import React, { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "components/misc/Headings.js";
import Header from "../headers/light.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import EmailIllustrationSrc from "images/email-illustration.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)((props) => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft
    ? tw`md:m-12 lg:mr-16 md:order-first`
    : tw`md:ml-12 lg:ml-16 md:order-last`,
]);

const Image = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-full`,
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(
  SectionHeading
)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;

const Form = tw.form`mt-8 md:mt-10 text-sm flex flex-col max-w-sm mx-auto md:mx-0`;
const Input = tw.input`mt-6 first:mt-0 border-b-2 py-3 focus:outline-none font-medium transition duration-300 hocus:border-primary-500`;
const Textarea = styled(Input).attrs({ as: "textarea" })`
  ${tw`h-24`}
`;

const SubmitButton = tw(PrimaryButtonBase)`inline-block mt-8`;

export default ({
  subheading = "Contact Us",
  heading = (
    <>
      Feel free to <span tw="text-primary-500">get in touch</span>
      <wbr /> with us.
    </>
  ),
  description = "Our dedicated customer support team is here to assist you and provide the necessary assistance.",
  submitButtonText = "Send",
  formAction = "#",
  formMethod = "get",
  textOnLeft = true,
}) => {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const { email, name, company_name, phone, country, message } = e.target;
    const url = `https://app.tabebek.com/public/contact-us?name=${name?.value}&email=${email?.value}&phone=${phone?.value}&company_name=${company_name?.value}&country=${country?.value}&message=${message?.value}`;

    const fetchTodos = async () => {
      try {
        const response = await fetch(url);
        const data = await response.json();
        if (data?.success) {
          toast(data?.message);
          setLoading(false);
          navigate("/");
        }
        // console.log(data);
      } catch (error) {
        console.log(error);
      }
    };
    if (
      name?.value !== "" &&
      email?.value !== "" &&
      phone?.value !== "" &&
      company_name?.value !== "" &&
      country?.value !== "" &&
      message?.value !== ""
    ) {
      setLoading(true);
      fetchTodos();
    } else {
      toast("Please fill all fields.");
    }
  };

  return (
    <>
      <Header roundedHeaderButton={false} />
      <Container>
        <TwoColumn>
          <ImageColumn>
            <Image imageSrc={EmailIllustrationSrc} />
          </ImageColumn>
          <TextColumn textOnLeft={textOnLeft}>
            <TextContent>
              {subheading && <Subheading>{subheading}</Subheading>}
              <Heading>{heading}</Heading>
              {description && <Description>{description}</Description>}
              <Form
                action={formAction}
                method={formMethod}
                onSubmit={(e) => handleSubmit(e)}
              >
                <Input type="text" name="name" placeholder="Full name" />
                <Input
                  type="text"
                  name="company_name"
                  placeholder="Company name"
                />
                <Input
                  type="email"
                  name="email"
                  placeholder="Email address"
                />
                <Input type="tel" name="phone" placeholder="Phone" />
                {/* <CountryInputField value={value} setValue={setValue} /> */}
                <Input type="text" name="country" placeholder="Country" />
                <Textarea name="message" placeholder="Type your message here..." />
                <SubmitButton type="submit">
                  {loading ? "loading..." : submitButtonText}
                </SubmitButton>
              </Form>
            </TextContent>
          </TextColumn>
        </TwoColumn>
        <div></div>
      </Container>
    </>
  );
};
